export const TRANSLATION_KEYS = {
  MissingSession: 'SignatureCallback.MissingSession',
  AccessDenied: 'SignatureCallback.AccessDenied',
  InvalidRequest: 'SignatureCallback.InvalidRequest',
  UnknownError: 'SignatureCallback.UnknownError',
  NetworkError: 'SignatureCallback.NetworkError',
  SuccessMessage: 'SignatureCallback.SuccessMessage',
  MaxAttemptsExceeded: 'SignatureCallback.MaxAttemptsExceeded',
  InvalidPin: 'SignatureCallback.InvalidPin',
  PinLocked: 'SignatureCallback.PinLocked',
  SessionExpired: 'SignatureCallback.SessionExpired',
  SessionNotFound: 'SignatureCallback.SessionNotFound',
  SessionInvalidStatus: 'SignatureCallback.SessionInvalidStatus',
  SignatureError: 'SignatureCallback.SignatureError',
  ValidationRequired: 'SignaturePin.ValidationRequired',
  ValidationPattern: 'SignaturePin.ValidationPattern',
  ValidationLength: 'SignaturePin.ValidationLength'
} as const;

export const CONFIG = {
  PIN_MIN_LENGTH: 6,
  PIN_MAX_LENGTH: 64,
  PIN_PATTERN: '^[0-9]+$',
  DOWNLOAD_DELAY_MS: 500,
} as const;
